import { ExperimentType, MessageMedium } from 'modules/graphql';
import { Nullable } from 'utils/tsHelpers';
import { ExperimentVariationInputArg, ExperimentVariationInputType } from '../types';

export const getVariantInputKeyAndType = (
  messageMedium: MessageMedium,
  experimentType: ExperimentType,
): Nullable<{
  variantInputKey: ExperimentVariationInputArg;
  variantInputType: ExperimentVariationInputType;
}> => {
  if (experimentType === ExperimentType.SendTime) {
    return {
      variantInputKey: ExperimentVariationInputArg.SEND_TIME,
      variantInputType: ExperimentVariationInputType.SEND_TIME,
    };
  }
  switch (messageMedium) {
    case MessageMedium.Email:
      return {
        variantInputKey: ExperimentVariationInputArg.EMAIL,
        variantInputType: ExperimentVariationInputType.EMAIL,
      };

    case MessageMedium.Push:
      return {
        variantInputKey: ExperimentVariationInputArg.PUSH,
        variantInputType: ExperimentVariationInputType.PUSH,
      };

    case MessageMedium.SMS:
      return {
        variantInputKey: ExperimentVariationInputArg.SMS,
        variantInputType: ExperimentVariationInputType.SMS,
      };

    case MessageMedium.WebPush:
      return {
        variantInputKey: ExperimentVariationInputArg.WEB_PUSH,
        variantInputType: ExperimentVariationInputType.WEB_PUSH,
      };

    default:
      return null;
  }
};
